<template>
  <div>
    <panel :title="title || 'Sales'" :footerShow="true">
      <div slot="headingElements" v-if="!tableOnly">
        <a class="btn btn-success" @click="addItemClick()"><i class="icon-add"></i> <span class="text-semibold">Add sale</span></a>
      </div>
      <div>
        <div ref="list" class="datatable-scroll scrollable">
          <table class="dataTable table table-togglable table-hover default footable tasks-list text-nowrap" role="grid" v-if="!dashboardLayout">
            <thead>
            <tr role="row">
              <th v-if="!tableOnly" tabindex="0" rowspan="1" colspan="1" data-sort-field="id" @click.prevent="toggleSort" style="width: 20px;">#</th>
              <th v-if="showColumns.deleteItem"></th>
              <th tabindex="0" rowspan="1" colspan="1" style="width: 1%;">Status</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="client" @click.prevent="toggleSort">Client</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="project" @click.prevent="toggleSort">Project</th>
              <th tabindex="0" rowspan="1" colspan="1" class="text-center" data-hide="phone">Apartments<br/><span class="text-muted">Total / Reserved / Sold</span></th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="creator" @click.prevent="toggleSort">Agent</th>
              <!-- th v-if="!tableOnly" tabindex="0" rowspan="1" colspan="1" class="text-center" data-sort-field="updated_at" @click.prevent="toggleSort" style="width: 15%;" data-hide="phone,tablet">Latest update</th -->
            </tr>
            </thead>
            <tbody>
            <tr v-if="!items.length" class="active border-double">
              <td colspan="8" class="text-semibold text-center">No data available</td>
            </tr>
            <tr @click="tryEditItem(item.id)" v-for="(item, idx) in items" :key="item.id" role="row" class="border-top-dashed-2px" v-bind:class="{'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2, 'cursor-pointer': tableOnly}" v-show="item.workflowStatus !== 'rejected'">
              <td v-if="!tableOnly" class=""><a href="#" @click.prevent="editItem(item.id)">#{{item.id | formatID}}</a></td>
              <td style="width: 1%;" v-if="showColumns.deleteItem">
                <ul class="icons-list">
                  <li><a @click.stop="itemDelete(item.id)"><i class="icon-trash"></i></a></li>
                </ul>
              </td>
              <td>
                <div class="btn-group">
                  <span class="label" :class="'label-default'">{{item.workflowStatus}}</span>
                </div>
              </td>
              <td>
                <div class="text-semibold" v-if="item.client">{{item.client.profile.first_name}} {{item.client.profile.last_name}} ( {{item.client.email}} )</div>
                <div class="text-semibold" v-else><i class="text-muted">(not set)</i></div>
              </td>
              <td>
                <div class="text-semibold" v-if="item.project"><a @click.stop="goToProject(item.project_id)">{{item.project.name}}</a></div>
                <div class="text-semibold" v-else><i class="text-muted">(not set)</i></div>
              </td>
              <td>
                <div class="text-semibold text-center">
                  {{item.totalApartments}} / {{item.reservedApartments}} / {{item.soldApartments}}
                </div>
              </td>
              <td>
                <div class="text-semibold" v-if="item.creator">{{item.creator.profile.first_name}} {{item.creator.profile.last_name}} ( {{item.creator.email}} )</div>
                <div class="text-semibold" v-else><i class="text-muted">(not set)</i></div>
              </td>
              <!-- td v-if="!tableOnly">
                <div class="input-group input-group-transparent text-center">
                  <div class="input-group-addon"><i class="icon-calendar2 position-left"></i></div>
                  <span v-if="item.updated_at">{{item.updated_at | moment(localizedFormat.fullDate)}}</span>
                  <span v-if="!item.updated_at">{{item.created_at | moment(localizedFormat.fullDate)}}</span>
                  <span v-if="!item.updated_at && !item.created_at"><i>never</i></span>
                </div>
              </td -->
            </tr>
            </tbody>
          </table>
          <table class="dataTable table table-togglable table-hover default footable tasks-list text-nowrap" role="grid" v-if="dashboardLayout">
            <thead>
            <tr role="row">
              <th tabindex="0" rowspan="1" colspan="1" style="width: 1%;">Status</th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="client" @click.prevent="toggleSort">Client</th>
              <th tabindex="0" rowspan="1" colspan="1" class="text-center" data-hide="phone">Apartments<br/><span class="text-muted">Total / Reserved / Sold</span></th>
              <th tabindex="0" rowspan="1" colspan="1" data-sort-field="creator" @click.prevent="toggleSort">Agent</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!items.length" class="active border-double">
              <td colspan="8" class="text-semibold text-center">No data available</td>
            </tr>
            <tr @click="tryEditItem(item.id)" v-for="(item, idx) in items" :key="item.id" role="row" v-bind:class="{'even': idx === 0 || idx % 2 === 0, 'odd': idx % 2, 'cursor-pointer': tableOnly}" v-show="item.workflowStatus !== 'rejected'">
              <td>
                <div class="btn-group">
                  <span class="label" :class="'label-default'">{{item.workflowStatus}}</span>
                </div>
              </td>
              <td>
                <div class="text-semibold" v-if="item.client">{{item.client.profile.first_name}} {{item.client.profile.last_name}} ( {{item.client.email}} )</div>
                <div class="text-semibold" v-else><i class="text-muted">(not set)</i></div>
              </td>
              <td>
                <div class="text-semibold text-center">
                  {{item.totalApartments}} / {{item.reservedApartments}} / {{item.soldApartments}}
                </div>
              </td>
              <td>
                <div class="text-semibold" v-if="item.creator">{{item.creator.profile.first_name}} {{item.creator.profile.last_name}} ( {{item.creator.email}} )</div>
                <div class="text-semibold" v-else><i class="text-muted">(not set)</i></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footerElements" v-if="!tableOnly">
        <div class="col-sm-12">
          <pagination :page="paging.page" :itemsPerPage="paging.perPage" :maxVisiblePage="5" :totalItems="paging.total" @page-change="__pageChanged"/>
        </div>
      </div>
    </panel>
    <overlay v-if="showLoader" message="Please wait..." html="<i class='icon-spinner2 icon-2x spinner'></i>"></overlay>
  </div>
</template>

<script>

import Vue from 'vue'

import SaleService from '@/services/sale.service'

import listMixin from '@/helpers/mixins/_listMixin'

export default {
  name: 'SaleIndex',
  mixins: [listMixin],

  props: {
    'tableOnly': {
      type: Boolean,
      default: false
    },
    'title': {
      type: String
    },
    'layout': {
      type: String,
      default: 'common'
    },
    'columns': {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  computed: {
    dashboardLayout: function () {
      return this.layout === 'dashboard'
    }
  },

  data () {
    return {
      id: null,
      itemTemplate: {
        showModal: false
      },
      showColumns: {
        // actions
        deleteItem: false
      },
      service: SaleService,
      saleStatuses: [
        'offer',
        'reservation',
        'closing',
        'closed',
        'rejected',
        'canceled'
      ]
    }
  },

  mounted () {
    this.showColumns = Object.assign(this.showColumns, this.columns || {})
    if (!this.tableOnly && this._is('superAdmin')) {
      this.showColumns.deleteItem = true
    }
  },

  methods: {
    reset (forceItemsReset = true) {
      this.id = null
      this.groupStatuses = Vue.config.statusGroups['sale'] ? Vue.config.statusGroups['sale'] : Vue.config.statusGroups['*']
      for (let i = 0; i < this.groupStatuses.length; i++) {
        this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
      }
    },

    itemDelete (id) {
      this.$popup.confirm('Are you sure you want to remove this offer?', 'Sale delete').then(() => {
        this.service.drop(id, () => {
          this.$popup.success('Offer has been removed successfully')
          this.refresh()
          this.$emit('itemDelete', id)
        })
      })
    },

    tryEditItem (id) {
      if (this.tableOnly) {
        this.editItem(id)
      }
    },

    goToProject (projectId) {
      this.$router.push('/project/details/' + projectId)
    },

    editItem (id) {
      this.$router.push('sale/details/' + id)
    },

    updateItemRow (i) {
      this.service.item(i.id, result => {
        i.workflowStatus = result.workflowStatus
        i.reservedApartments = result.reservedApartments
        i.soldApartments = result.soldApartments
        i.totalApartments = result.totalApartments
        i.updated_at = result.updated_at
      })
    },

    addItemClick () {
      this.$router.push('sale/add')
    },

    canBeChanged (object) {
      let result = typeof object === 'object'
      if (result) {
        result = result && object.hasOwnProperty('id') && object.id
      }
      result = result && object.status === 1
      return result
    },

    setSaleStatus (item, status) {
      let $vm = this
      this.service.workflowUpdate(item, status, () => {
        $vm.items.forEach((i, idx) => {
          if (item === parseInt(i.id)) {
            $vm.updateItemRow(i)
          }
        })
      }, () => {
        $vm.$popup.warning('Can\'t set item STATUS on server')
      })
    }
  }
}
</script>

<style scoped>

</style>
